var map = {
	"./callingcards.svg": "0089",
	"./cashcards.svg": "bdbc",
	"./dr.svg": "6370",
	"./flixbus.svg": "18b6",
	"./giftcards.svg": "f084",
	"./invoices.svg": "e5d2",
	"./ir.svg": "2c2e",
	"./reclaim.svg": "073f",
	"./reports.svg": "abde",
	"./users.svg": "40b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "488f";